<script setup lang="ts">
import type { NuxtError } from '#app/composables/error'

const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    default: () => ({ statusCode: 500, message: 'An unexpected error occurred' })
  }
})

const { t } = useI18n()
const handleError = () => {
  console.error('Page error:', props.error)
  clearError({ redirect: t('app.safetyLink.to') })
}
</script>

<template>
  <div class="container mx-auto">
    <Logo />
    <div class="flex h-screen flex-col justify-center">
      <div class="mx-auto w-full max-w-4xl">
        <div class="flex">
          <div class="text-3xl font-bold">{{ error?.statusCode }}</div>
          <h1 class="self-center pl-2 text-lg">{{ error?.message }}</h1>
        </div>
        <div class="font-sm mt-5">
          <Button class="cursor-pointer underline" @click="handleError">{{
            $t('app.safetyLink.label')
          }}</Button>
        </div>
      </div>
    </div>
  </div>
</template>
